
export default function Title3Module(element) {

    element.style.setProperty('--scrollwidth', (element.scrollWidth - element.clientWidth) + 'px');

    element.querySelector('.title3__wrapper').style.setProperty('animation-name', 'title3anim')
    
    // let tl = gsap.timeline({repeat: -1, yoyo: true});

    // let $wrapper = element.querySelector('.title3__wrapper');

    // let scrollWidth = $wrapper.scrollWidth;
    // let width = $wrapper.clientWidth;

    // let targetX = (scrollWidth - width) * -1;
    // // let targetX = scrollWidth * -1;

    // tl.to($wrapper, { x: targetX, duration: 25, ease: 'none' })

}
